import find from "lodash/find";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { CustomType, Id } from "PFTypes";
import { useCallback, useMemo } from "react";

const PROFILE_PILL_SECTION_KEY = "profile_pill";

type ProfilePill = { customTypeId: number; text: string };

type UseProfilePillSectionCustomTypesReturn = {
  profilePillCustomTypes: CustomType[];
  getValue: (pills: ProfilePill[], customTypeId: Id) => string;
};

export const useProfilePillSectionCustomTypes = (): UseProfilePillSectionCustomTypesReturn => {
  const { customTypes } = useCustomTypes();

  const profilePillCustomTypes = useMemo(
    () =>
      customTypes.filter(
        ({ sections, permitted }) => !!permitted && find(sections || [], ["key", PROFILE_PILL_SECTION_KEY])
      ),
    [customTypes]
  );

  const getValue = useCallback(
    (pills: ProfilePill[], customTypeId: Id): string =>
      pills
        .filter(({ customTypeId: id }) => id === customTypeId)
        .map(({ text }) => text)
        .join(", "),
    []
  );

  return { profilePillCustomTypes, getValue };
};
